import {
  EuiButton,
  EuiFieldText,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFormRow,
  EuiPanel,
  EuiText,
  EuiTextArea,
} from "@elastic/eui";
import { Addon, AddonBillingType } from "../../api/entities/Addon";
import { NumberToCurrency } from "../../utils/Formatters";

export interface IAddonEditor {
  addon: Addon;
  onUpdateAddon: (addon: Addon) => void;
  onSaveClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

export const AddonEditor: React.FC<IAddonEditor> = (props) => {
  const onSaveClick = () => {
    props.onSaveClick();
  };

  return (
    <EuiPanel hasBorder={true} hasShadow={false}>
      <EuiFormRow label={"Addon Name"}>
        <EuiFieldText
          value={props.addon.name}
          onChange={(e) =>
            props.onUpdateAddon({ ...props.addon, name: e.target.value })
          }
        />
      </EuiFormRow>
      <EuiFormRow label={"Addon Description"}>
        <EuiTextArea
          value={props.addon.description}
          onChange={(e) =>
            props.onUpdateAddon({ ...props.addon, description: e.target.value })
          }
        />
      </EuiFormRow>
      <EuiFormRow label={"Addon Price"}>
        <EuiText>
          <p>
            {NumberToCurrency(props.addon.price)}
            {props.addon.addonBillingType === AddonBillingType.ParentRecurring
              ? " / month"
              : ""}
          </p>
        </EuiText>
      </EuiFormRow>
      <EuiFormRow>
        <EuiFlexGroup>
          <EuiFlexItem grow={false}>
            <EuiButton
              fill
              isLoading={props.isLoading}
              isDisabled={props.isDisabled}
              onClick={onSaveClick}
            >
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFormRow>
    </EuiPanel>
  );
};
